import CheckIcon from "@mui/icons-material/CheckRounded";
import { Box, Chip, Link, Typography } from "@mui/material";
import * as React from "react";
// Import Swiper React components
import { styled } from "@mui/material/styles";
import { useSliderPreview } from "components/swiper";
import { useTemplate } from "containers/templateDetail/store";
import { Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

export const Image = styled("img")(({ theme }) => ({
  width: "100%",
  borderRadius: 4,
  border: "1px solid",
  boxSizing: "border-box",
  borderColor: theme.palette.grey[300],
}));

export default function Customization(): React.ReactElement {
  const { files, initAreas: areas, images } = useTemplate();
  const { slidesPerView, xs: matchesXS } = useSliderPreview();

  return (
    <Box>
      <Box sx={{ maxWidth: 400 }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: (theme) => theme.typography.fontWeightSemiBold }}
        >
          DTG
        </Typography>
        <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap" }}>
          {areas.map((area) => {
            return (
              <Chip
                key={area.id}
                label={area.title}
                icon={<CheckIcon fontSize="small" />}
                sx={{ mr: 1, mb: 1, px: 1 }}
              />
            );
          })}
        </Box>
      </Box>
      {/* <Divider sx={{ my: 2 }} /> */}
      {files.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography
            variant="body1"
            sx={{ fontWeight: (theme) => theme.typography.fontWeightSemiBold }}
          >
            Design Guideline Files
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Link href={files[0].src} target="_blank">
              Download
            </Link>
          </Box>
        </Box>
      )}
      {/* <Divider sx={{ my: 2 }} /> */}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="body1"
          sx={{ fontWeight: (theme) => theme.typography.fontWeightSemiBold }}
        >
          Available mockup styles
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Swiper
            slidesPerView={slidesPerView}
            spaceBetween={30}
            modules={[Mousewheel]}
            mousewheel
          >
            {images.map((image) => {
              return (
                <SwiperSlide
                  key={image.id}
                  style={
                    matchesXS
                      ? {
                          width: "80%",
                        }
                      : {}
                  }
                >
                  <Image src={image.src} />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
      </Box>
    </Box>
  );
}
